import React, { useEffect, useState } from 'react'
import { auth, db } from '../firebase'
import Price from '../Components/Price'
import Container from '@material-ui/core/Container';
import { withRouter } from "react-router-dom";
import { useParams } from 'react-router-dom';
import Button from '@material-ui/core/Button';

const ProductDetail = (props) => {

    const [data, setData] = useState([])

    const [loading, setLoading] = useState(true);
    const {phone} = useParams();


    const product = {
        title: "Wireless Headphones",
        description:
        "High-quality wireless headphones with noise cancellation and 20-hour battery life.",
        price: "$129.99",
        image:
        "https://images.unsplash.com/photo-1580894908361-ec45b8f2c55f?auto=format&fit=crop&w=600&q=80",
    };

    useEffect(() => {
        // auth.onAuthStateChanged(user => {
        //     db.collection("orders").where("phone", "==", phone).get()
        //     .then(function (querySnapshot) {
        //         setLoading(false)
        //         //console.log(querySnapshot)
        //         querySnapshot.forEach(function (doc) {
        //             // doc.data() is never undefined for query doc snapshots
        //             //console.log(doc.id, " => ", doc.data());
        //             setData(prevData => prevData.concat(doc.data()))
        //         });
        //     });
        // })
    }, [])

    return (
        <div>
            
        </div>
    );
}

export default withRouter(ProductDetail)